import { render, staticRenderFns } from "./CustomersTable.vue?vue&type=template&id=3ab46529&scoped=true&"
import script from "./CustomersTable.vue?vue&type=script&lang=ts&"
export * from "./CustomersTable.vue?vue&type=script&lang=ts&"
import style0 from "./CustomersTable.vue?vue&type=style&index=0&id=3ab46529&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab46529",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
